__turbopack_context__.v({
  "checkbox": "CheckBox-module-scss-module__mSpxxq__checkbox",
  "checkbox-icon": "CheckBox-module-scss-module__mSpxxq__checkbox-icon",
  "checkbox-wrapper": "CheckBox-module-scss-module__mSpxxq__checkbox-wrapper",
  "disabled": "CheckBox-module-scss-module__mSpxxq__disabled",
  "error": "CheckBox-module-scss-module__mSpxxq__error",
});
